import { AppDownloadAnchorLink } from 'app/marketing/components/AppDownloadAnchorLink'

interface Props {
  className?: string
  buttonStyles?: string
  text?: string
}

export const MLPDownloadAppCTA = ({
  className = '',
  buttonStyles = '',
  text = 'Download the app',
}: Props) => (
  <AppDownloadAnchorLink
    className={className}
    buttonStyles={buttonStyles}
    title={text}
    anchor={{ id: 'download-app', offset: 160 }}
  />
)
